export class Commodities {
    CountryOfManufacture: any; 
    CustomsValue: number; 
    Description: any; 
    NumberOfPieces: any; 
    Quantity: any;  
    UnitPrice: any; 
}
 